"use strict";

exports.__esModule = true;
exports.TimelineValue = void 0;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireWildcard(require("react"));
var _Measures = require("../../Measures");
var _excluded = ["label", "width", "height", "timeline", "value", "color", "backgroundColor", "textAnchor", "fontSize"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a single value from a timeline.
 */
var TimelineValue = exports.TimelineValue = /*#__PURE__*/function (_Component) {
  function TimelineValue() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(TimelineValue, _Component);
  var _proto = TimelineValue.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      label = _this$props.label,
      width = _this$props.width,
      height = _this$props.height,
      timeline = _this$props.timeline,
      value = _this$props.value,
      color = _this$props.color,
      backgroundColor = _this$props.backgroundColor,
      textAnchor = _this$props.textAnchor,
      fontSize = _this$props.fontSize,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var labelFontSize = 0;
    if (typeof label === "string" && label.length > 0) {
      labelFontSize = Math.max(Math.min(18, width / (label.length * 0.8), height / 2 - 4), 8);
      if (fontSize && labelFontSize > fontSize) {
        labelFontSize = fontSize;
      }
    }
    var labelHeight = labelFontSize > 0 ? labelFontSize + 8 : 0;
    var element;
    var textColor = backgroundColor ? "#000" : color;
    if (value == null) {
      element = null;
    } else if (timeline.subscriptionProps && timeline.subscriptionProps.responseKey !== undefined && timeline.subscriptionProps.element) {
      var RenderElement = timeline.subscriptionProps.element;
      element = /*#__PURE__*/_react["default"].createElement(RenderElement, {
        width: width,
        height: height - labelHeight,
        value: timeline.subscriptionProps.responseKey ? (0, _path2["default"])(timeline.subscriptionProps.responseKey, value) : value,
        fontSize: fontSize,
        textAnchor: textAnchor,
        color: textColor || "currentColor"
      });
    } else {
      element = /*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
        width: width,
        height: height - labelHeight,
        value: JSON.stringify(value.value),
        fontSize: fontSize,
        textAnchor: textAnchor,
        color: textColor || "currentColor"
      });
    }
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      width: width,
      height: height
    }, extra), backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: backgroundColor
    }), element, label && /*#__PURE__*/_react["default"].createElement("text", {
      x: width / 2,
      y: height - labelHeight,
      fontSize: labelFontSize,
      fill: textColor || "currentColor",
      textAnchor: textAnchor,
      alignmentBaseline: "hanging"
    }, label));
  };
  return TimelineValue;
}(_react.Component);